import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'bam-quote',
  styleUrl: 'bam-quote.scss',
  shadow: false,
})
export class BamQuote {
  @Prop() isFlat?: boolean = false
  @Prop() author?: string
  @Prop() jobTitle?: string
  @Prop() btnTitle?: string
  @Prop() btnLink?: string
  @Prop() spacing: string = ""

  render() {
    return (
      <Host>
        <bal-card flat={this.isFlat} class={`${this.spacing}`} color="white">
          <div
            class={{
              'mx-medium': !this.isFlat,
            }}>
            <slot name="headline"/>
            <slot name="quote" />
            <div class="bam-quote__image-cta-wrapper">
              <div class="bam-quote__image-wrapper">
                <div class="bam-quote__image">
                  <slot name="image"/>
                </div>
                <div class="bam-quote__author">
                  <p class="title text-medium mb-none">{this.author}</p>
                  {this.jobTitle &&
                    <p class="mb-none mt-xx-small">{this.jobTitle}</p>
                  }
                </div>
              </div>
              {this.btnLink &&
                <bal-button color="link" href={this.btnLink} icon="plus">{this.btnTitle}</bal-button>
              }
            </div>
          </div>
        </bal-card>
      </Host>
    );
  }

}
